import { ColumnsProps } from 'components/Table/Table'
import { getLineTypeByTheme, LINE_TYPES } from 'config/theme.config'
import i18n from 'i18n'

const allColumns = (): ColumnsProps[] => [
  {
    align: 'right',
    fixed: true,
    name: 'fazCode',
    title: i18n.t('tables:code')
  },
  {
    align: 'left',
    fixed: true,
    name: 'fazName',
    title: i18n.t('tables:corporateNameOwnership')
  },
  {
    align: 'left',
    name: 'producerName',
    title: i18n.t('tables:producerName')
  },
  {
    align: 'right',
    name: 'producerDoc',
    title: i18n.t('tables:producerDocument')
  },
  {
    align: 'right',
    name: 'fazCarNumber',
    title: i18n.t('tables:carNumber')
  },
  {
    align: 'left',
    name: 'city',
    title: i18n.t('common:city')
  },
  {
    align: 'left',
    name: 'state',
    title: i18n.t('tables:UF')
  },
  {
    align: 'right',
    name: 'qtyInvoice',
    title: i18n.t('tables:quantityOrders')
  },
  {
    align: 'left',
    fixed: false,
    name: 'analyze',
    title: i18n.t('common:analyze')
  }
]

// Column name lists for each type
export const INNATURA_COLUMNS = [
  'fazCode',
  'fazName',
  'producerName',
  'producerDoc',
  'fazCarNumber',
  'city',
  'state',
  'qtyInvoice',
  'analyze'
]

export const PROCESSADOS_COLUMNS = [
  'fazCode',
  'fazName',
  'producerName',
  'producerDoc',
  'fazCarNumber',
  'city',
  'state',
  'qtyInvoice',
  'analyze'
]

export const DISTRIBUTION_COLUMNS = [
  'nr_pedido',
  'fazCarNumber',
  'dt_abate',
  'producerDoc',
  'fazName',
  'city',
  'state',
  'analyze'
]

/**
 * Get columns filtered by business type
 * @param type - Type of columns to return (INNATURA, PROCESSADOS, DISTRIBUTION)
 * @param theme - Current theme (optional, used for conditional filtering)
 * @returns Filtered column list
 */
export const getColumnsByTheme = (theme: string): ColumnsProps[] => {
  const allColumnsList = allColumns()

  const type = getLineTypeByTheme(theme)

  let columnNames: string[] = []

  switch (type) {
    case LINE_TYPES.INNATURA:
      columnNames = INNATURA_COLUMNS
      break
    case LINE_TYPES.PROCESSED:
      columnNames = PROCESSADOS_COLUMNS
      break
    case LINE_TYPES.DISTRIBUTION:
      columnNames = DISTRIBUTION_COLUMNS
      break
    default:
      return allColumnsList
  }

  return columnNames
    .map(name => allColumnsList.find(col => col.name === name))
    .filter(Boolean) as ColumnsProps[]
}

export const columns = (): ColumnsProps[] =>
  getColumnsByTheme(LINE_TYPES.INNATURA)
